export default __webpack_public_path__ + "static/media/discord.c2b40b20.gif";